import {BounceLogo, CloseDialogButton, Container} from "@bounce/shared/ui";
import React from "react";
import {useConsumerMenu} from "../context/MenuContext";

const MenuHeader = () => {
  const {handleClose} = useConsumerMenu();

  return (
    <Container
      row
      sx={{
        padding: "10px 8px",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      <BounceLogo width={"120px"} height={"24px"} />
      <CloseDialogButton sx={{top: 13}} onClose={handleClose} />
    </Container>
  );
};

export default MenuHeader;
